import { API_PATH } from "../../../constants";
import { axiosRequest } from "../../api";

export const IhioPrescriptionFillingsService = {
  writtenPrescriptionAdmission(data: any) {
    return axiosRequest(
      "POST",
      API_PATH.IHIO_PRESCRIPTION_FILLING.ADMISSION,
      data
    );
  },
  writtenPrescriptionPrintOrder(data: any) {
    return axiosRequest(
      "POST",
      API_PATH.IHIO_PRESCRIPTION_FILLING.PRINT_ORDER,
      data
    );
  },
  getIhioDeliverCheckCode(data: any) {
    return axiosRequest(
      "POST",
      API_PATH.IHIO_PRESCRIPTION_FILLING.CHECK_CODE_DELIVER,
      data
    );
  },
  sendIhioPrescriptionFilling(data: any) {
    return axiosRequest(
      "POST",
      API_PATH.IHIO_PRESCRIPTION_FILLING.DELIVER_SEND,
      data
    );
  },
  getFilledPrescriptionPrint(data: any) {
    return axiosRequest(
      "POST",
      API_PATH.IHIO_PRESCRIPTION_FILLING.PRINT_DELIVER,
      data
    );
  },
  getDeliveredPrescription(data: any) {
    return axiosRequest(
      "POST",
      API_PATH.IHIO_PRESCRIPTION_FILLING.GET_DELIVER,
      data
    );
  },
  getOrderedPrescription(data: any) {
    return axiosRequest(
      "POST",
      API_PATH.IHIO_PRESCRIPTION_FILLING.GET_ORDER,
      data
    );
  },
  getFilledPrescriptionDeliverList(params: any) {
    return axiosRequest(
      "GET",
      API_PATH.IHIO_PRESCRIPTION_FILLING.DELIVER_LIST(params)
    );
  },
  getHistoryPrescriptionOrderList(params: any) {
    return axiosRequest(
      "GET",
      API_PATH.IHIO_PRESCRIPTION_FILLING.ORDER_LIST(params)
    );
  },
  getIhioBillCheck() {
    return axiosRequest("GET", API_PATH.IHIO_PRESCRIPTION_FILLING.BILL_CHECK);
  },
  getIhioBillList(data: any) {
    return axiosRequest(
      "POST",
      API_PATH.IHIO_PRESCRIPTION_FILLING.BILL_LIST,
      data
    );
  },
  getPrescriptionReferralList(params: any) {
    return axiosRequest(
      "GET",
      API_PATH.IHIO_PRESCRIPTION_FILLING.REFERRAL_LIST(params)
    );
  },
  getPrescriptionReferralInfo(data: any) {
    return axiosRequest(
      "POST",
      API_PATH.IHIO_PRESCRIPTION_FILLING.REFERRAL_INFO,
      data
    );
  },
};
